export type TestLanguage = 'es' | 'en';

export const resolveTestLanguage = (searchParams: URLSearchParams): TestLanguage => {
  const explicitLang = (searchParams.get('lang') || searchParams.get('locale') || '').toLowerCase();
  if (explicitLang.startsWith('en')) return 'en';
  if (explicitLang.startsWith('es')) return 'es';

  const storedLang = (window.localStorage.getItem('i18nextLng') || window.localStorage.getItem('language') || '').toLowerCase();
  if (storedLang.startsWith('en')) return 'en';

  return 'es';
};

export const testMessages = {
  es: {
    heading: 'Cuestionario de perfil de aprendizaje',
    intro: 'Responde todas las preguntas. No hay respuestas correctas o incorrectas: sirven para conocer cómo aprendes.',
    loadingQuestions: 'Cargando preguntas...',
    loadErrorTitle: 'Error al cargar las preguntas',
    loadErrorMessage: 'No se pudieron cargar las preguntas. Por favor, intenta de nuevo más tarde.',
    cannotStart: 'No se puede iniciar el test',
    invalidStudentId: 'Este test necesita un studentId válido para poder guardar el resultado del alumno.',
    invalidReturnUrl: 'La URL de retorno no es válida o no está permitida.',
    backHome: 'Volver al inicio',
    studentSessionBadge: 'Sesión del alumno',
    studentSession: (name: string) => `Sesión de ${name}`,
    anonymousStudent: 'alumno',
    center: (id: string) => `Centro ${id}`,
    account: (email: string) => `Cuenta: ${email}`,
    privacyTitle: 'Privacidad y uso educativo',
    privacyText: 'Tus respuestas se usan para orientar tu perfil de aprendizaje y adaptar el acompañamiento educativo. Solo el equipo autorizado del centro debe revisar esta información.',
    answeredCount: (answered: number, total: number) => `${answered} de ${total} respondidas`,
    previous: 'Anterior',
    next: 'Siguiente',
    pageIndicator: (current: number, total: number) => `Página ${current} de ${total}`,
    submitting: 'Enviando',
    finish: 'Finalizar y Ver Resultados',
    incompleteTitle: 'Respuestas incompletas',
    incompleteDescription: 'Por favor responde todas las preguntas antes de enviar.',
    submitErrorTitle: 'Error al enviar respuestas',
    submitErrorDescription: 'Hubo un problema al procesar tus respuestas. Por favor, intenta de nuevo.',
    missingStudentOnSubmit: 'No se encontró un studentId válido para guardar el resultado.',
    likert: [
      'Totalmente en desacuerdo',
      'En desacuerdo',
      'Neutral',
      'De acuerdo',
      'Totalmente de acuerdo',
    ],
    selected: 'Seleccionada',
  },
  en: {
    heading: 'Learning profile questionnaire',
    intro: 'Answer every question. There are no right or wrong answers: they help us understand how you learn.',
    loadingQuestions: 'Loading questions...',
    loadErrorTitle: 'Error loading questions',
    loadErrorMessage: 'Questions could not be loaded. Please try again later.',
    cannotStart: 'The test cannot be started',
    invalidStudentId: 'This test needs a valid studentId to save the student result.',
    invalidReturnUrl: 'The return URL is invalid or not allowed.',
    backHome: 'Back to home',
    studentSessionBadge: 'Student session',
    studentSession: (name: string) => `Session for ${name}`,
    anonymousStudent: 'student',
    center: (id: string) => `Center ${id}`,
    account: (email: string) => `Account: ${email}`,
    privacyTitle: 'Privacy and educational use',
    privacyText: 'Your answers are used to guide your learning profile and adapt educational support. Only the authorized school team should review this information.',
    answeredCount: (answered: number, total: number) => `${answered} of ${total} answered`,
    previous: 'Previous',
    next: 'Next',
    pageIndicator: (current: number, total: number) => `Page ${current} of ${total}`,
    submitting: 'Submitting',
    finish: 'Finish and View Results',
    incompleteTitle: 'Incomplete answers',
    incompleteDescription: 'Please answer all questions before submitting.',
    submitErrorTitle: 'Error submitting answers',
    submitErrorDescription: 'There was a problem processing your answers. Please try again.',
    missingStudentOnSubmit: 'A valid studentId was not found to save the result.',
    likert: [
      'Strongly disagree',
      'Disagree',
      'Neutral',
      'Agree',
      'Strongly agree',
    ],
    selected: 'Selected',
  },
} as const;

export type TestMessages = typeof testMessages[TestLanguage];
